import { render, staticRenderFns } from "./basictwocolumnform.vue?vue&type=template&id=91058202"
import script from "./basictwocolumnform.vue?vue&type=script&lang=js"
export * from "./basictwocolumnform.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports